import React, { useState } from "react";
import "@/App.css";
import { AppProvider, useApp } from "@/context/AppContext";
import { Header } from "@/components/Header";
import { AuthModal } from "@/components/AuthModal";
import { LandingPage } from "@/pages/Landing";
import { CustomerHub } from "@/pages/CustomerHub";
import { AdminLogin } from "@/pages/AdminLogin";
import { AdminDashboard } from "@/pages/AdminDashboard";
import { Toaster } from "sonner";
import { TermsAndConditions } from "./TermsAndConditions";
function Shell() {
  const { route, session } = useApp();
  const [authOpen, setAuthOpen] = useState(false);

  // Admin gateway is entirely hidden from public UI
  const isAdminRoute =
    route === "admin-gateway" || route === "admin-dashboard" || session?.role === "admin";

  if (isAdminRoute) {
    if (session?.role === "admin") {
      return (
        <div>
          <Header onLoginClick={() => setAuthOpen(true)} />
          <AdminDashboard />
        </div>
      );
    }
    return <AdminLogin />;
  }

  // Customer routes
  return (
    <div>
      <Header onLoginClick={() => setAuthOpen(true)} />
      {route === "customer-hub" && session?.role === "customer" ? (
        <CustomerHub />
      ) : (
        <LandingPage onLoginClick={() => setAuthOpen(true)} />
      )}
      <AuthModal open={authOpen} onClose={() => setAuthOpen(false)} />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <AppProvider>
        <Shell />
        <Toaster
          theme="light"
          position="top-right"
          toastOptions={{
            style: {
              background: "#ffffff",
              border: "1px solid #e7e2d9",
              color: "#0f0f10",
              fontFamily: "Plus Jakarta Sans, sans-serif",
              borderRadius: "12px",
            },
          }}
        />
      </AppProvider>
    </div>
  );
}

export default App;
